import styled from 'styled-components'
import * as BaseStyles from '../BaseStyles'

export const PriceTypeBoxDiv = styled(BaseStyles.Div)`
    box-shadow:
    0 0px 2px rgba(0, 0, 0, 0.022),
    0 0px 3px rgba(0, 0, 0, 0.031),
    0 0px 4px rgba(0, 0, 0, 0.039),
    0 0px 5px rgba(0, 0, 0, 0.048),
    0 0px 6px rgba(0, 0, 0, 0.07)
    ;
    width: 30rem;
    height: 36rem;
    color: black;
    border-radius: 1.5rem;
    background-color: white;
    padding: 1.5rem;
    margin: 0rem 0.5rem;
    display: inline-block;
`

export const PricingTypeBoxContentsDiv = styled(BaseStyles.Div)`
    height: 36rem;
    border-top: 0.001rem solid #E8E8E8;
    border-bottom: 0.001rem solid #E8E8E8;
`

export const PriceTypeTierDiv = styled(BaseStyles.Div)`
    width: 100%;
    height: 3.6rem;
    text-align: center;
`

export const PriceTypeCostDiv = styled(BaseStyles.Div)`
    width: 100%;
    height: 3.6rem;
    text-align: center;
    border-bottom: 0.001rem solid #E8E8E8;
`

export const PriceTypePerksDiv = styled(BaseStyles.Div)`
    width: 100%;
    height: 28.8rem;
`

export const PriceTypeTierText = styled.h2`
    margin: 0;
    padding: 0;
    font-size: 2.2rem;
`

export const PriceTypeCostText = styled.h2`
    margin: 0;
    padding: 0;
    font-size: 2.2rem;
`
export const PerkList = styled.ul`
    margin: 0rem 1.5rem;
    margin-top: 1rem;
    position: relative;
	list-style: none;
    padding: 0;
`

export const PerkListItem = styled.li`
    font-size: 1.6rem;
    margin: 1rem 0rem;
    padding: 0;
    &:before{
        content: '→';
        position: absolute;
        left: -1.5rem;
        color: #4267B2;
    }
`